import {ProductPageLocalisation} from "../product-models";

export const i18n = (resourceKey:string, localisations:ProductPageLocalisation[]) => {
    return localisations.find(l => l.ResourceKey === resourceKey)?.ResourceValue ?? `i18n error for ${resourceKey}!`;
}

//overload, replacing each instance of {0} with the corresponding value in the array
export const i18nArray = (resourceKey:string, localisations:ProductPageLocalisation[], ...args:string[]) => {
    let result = i18n(resourceKey, localisations);
    args.forEach((arg, index) => {
        result = result.replace(`{${index}}`, arg);
    });
    return result;
}